import type { BranchNameType } from '../types.js'

export class CommonSystemBridge {
	private static _branchName: BranchNameType
	static get branchName() {
		return this._branchName
	}
	static set branchName(branchName: BranchNameType) {
		if (!this._branchName) this._branchName = branchName
	}
}
